@if (statistics.activeUsersTabDataLoaded) {
  <div class="row">
    <div class="col">
      <div>
        <active-users-per-day
          [activeUsersByDay]="activeUsersData.activeUsersByDays"
        ></active-users-per-day>
      </div>
      <div class="mt-3">
        <active-users-per-hour
          [activeUsersByHour]="activeUsersData.activeUsersByHours"
          >
        </active-users-per-hour>
      </div>
    </div>
  </div>
} @else {
  <img
    class="fadeLoader centerLoader logoSmall"
    src="assets/img/loading_logo.svg"
    />
  }

